import { render, staticRenderFns } from "./ModalInicio.vue?vue&type=template&id=77578cbd"
import script from "./ModalInicio.vue?vue&type=script&lang=js"
export * from "./ModalInicio.vue?vue&type=script&lang=js"
import style0 from "./ModalInicio.vue?vue&type=style&index=0&id=77578cbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports